import React from 'react'
import { TableCell, TableRow, IconButton, Chip } from '@mui/material'
import eyeIcon from 'src/assets/icons/eyeIcon.png'
import dayjs from 'dayjs'
import { TransactionI } from 'src/api/manageProductsApi/types'

type DataRowProps = {
  transaction: TransactionI
  onViewDetailsClick: (transaction: TransactionI) => void
}
const DataRow = ({ transaction, onViewDetailsClick }: DataRowProps) => {
  return (
    <TableRow hover tabIndex={-1}>
  

      <TableCell>{transaction.id}</TableCell>
      <TableCell>{transaction.amount_payable}</TableCell>
      <TableCell>{transaction.status}</TableCell>
      <TableCell>{ dayjs(transaction.created_at).format('DD MMM YYYY, hh:mm a') }</TableCell>

      <TableCell align='center'>
        <IconButton onClick={() => onViewDetailsClick(transaction)}>
          {' '}
          <img src={eyeIcon} alt='eyeIcon' />{' '}
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default DataRow
